import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';
import type { CategoryClick } from '@/hooks/affiliate/useAffiliateAnalytics';

interface ClicksByCategoryChartProps {
  data: CategoryClick[];
}

export const ClicksByCategoryChart = ({ data }: ClicksByCategoryChartProps) => {
  return (
    <Card className="mt-6">
      <CardHeader>
        <CardTitle>Clicks By Category</CardTitle>
        <CardDescription>Affiliate clicks grouped by partner category</CardDescription>
      </CardHeader>
      <CardContent>
        <ResponsiveContainer width="100%" height={300}>
          <BarChart data={data}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="category" />
            <YAxis />
            <Tooltip />
            <Legend />
            <Bar 
              dataKey="clicks" 
              fill="hsl(var(--primary))" 
              name="Clicks"
            />
          </BarChart>
        </ResponsiveContainer>
      </CardContent>
    </Card>
  );
};
